import React from 'react'
import { Box, Typography } from '@mui/material'
import { Block } from '@mui/icons-material'

import { isPrivate } from '../utils/config'

const NotFound = () => {
  return (
    <Box className='d-flex justify-content-center align-items-center' sx={{height: '100vh'}}>
      {isPrivate &&
        <Typography className='position-absolute' sx={{top: '1rem', left: '1rem'}} variant='caption'>
          Internal
        </Typography>
      }
      <Box className='d-flex flex-column align-items-center gap-4 p-5'>
        <Block sx={{ fontSize: 100 }} color='error' />
        <Typography component='h1' variant="h5">Page Not Found</Typography>
      </Box>
    </Box>
  )
}

export default NotFound
